export const A11Y = {
    ButtonId: {
        VPA: 'upi-button-vpa',
        QR: 'upi-button-qrCode',
        INTENT: 'upi-button-intent'
    },
    AreaId: {
        VPA: 'upi-area-vpa',
        QR: 'upi-area-qrCode',
        INTENT: 'upi-area-intent'
    }
};
